module.exports = __webpack_public_path__ + "img/icon-stars.b8683759.svg";